export default "__VITE_ASSET__C77LLntl__"